import actions from "@/store/actions";
import utils from "@/utils";
import api from "@/api";

export const fetchResume = () => {
  return async (dispatch) => {
    const date = new Date().toISOString();
    dispatch(actions.resumeActions.fetchresume(date));
  };
};

export const resetResume = () => {
  return async (dispatch) => {
    const date = new Date().toISOString();
    dispatch(actions.resumeActions.resetresume(date));
  };
};

export const getCurrentResume = (resumeId, templateId) => {
  return async (dispatch) => {
    const res = await api.getResume(resumeId);

    if (res?.data?.success === 200) {
      dispatch(actions.resumeActions.fetchresume(res?.data?.result));
      utils.addToLocalStorage("ResumeData", {
        _id: resumeId,
        templateId,
        ...res.data.result,
      });
    }
  };
};
